import DietaryRestriconsAccordion from "@components/store/product-detail/shared/accordion/dietary-restrictions";
import IngredientsAccordion from "@components/store/product-detail/shared/accordion/ingredients";
import OrderInstructions from "@components/store/product-detail/shared/accordion/order-instructions";

import styles from "./main.module.scss";
const PropertiesAccordionList = ({
  restrictions,
  ingredients,
  instructions,
  accordionClass = "",
  productId,
}) => {
  return (
    (restrictions?.length > 0 || ingredients?.length > 0 || instructions?.length > 0) && (
      <div
        className={`${styles.accordionContainer} ${accordionClass} cmn-accordion-box`}
        data-group="accordion"
      >
        {restrictions?.length > 0 && (
          <DietaryRestriconsAccordion restrictions={restrictions} productId={productId} />
        )}
        {ingredients?.length > 0 && <IngredientsAccordion ingredients={ingredients} />}
        {instructions?.length > 0 && (
          <OrderInstructions instructions={instructions} productId={productId} />
        )}
      </div>
    )
  );
};

export default PropertiesAccordionList;
